import React, { Component } from "react";
import "./css/login.css";
import { get } from "lodash";
import {authenticateGeneratedOTP, getDrayagePartnersList, getUserInfo, login, sendKnEmail, specificUserLogin} from "../../components/container/api/index";
import { Button, Segment, Loader, Form, Header, Checkbox, Select, Label, Icon, Image, Modal, Radio, Dropdown } from "semantic-ui-react";
import {Link} from 'react-router-dom'
import { Input, FreeForm, FormRow } from "kx-common-components";
import 'semantic-ui-css/semantic.min.css';
import { isListedAdminEmail, checkEnvForProd } from "../../util";


class LoginDrayage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            toNextPage: false,
            username: "",
            password: "",
            rememberMe: "",
            usernameError: false,
            passwordError: false,
            showPopup: false,
            error: false,
            loading: false,
            showKnEmailInput: false,
            knEmail: '',
            useCurrentEmail: false,
            showOtpModal: false,
            otp: '',
            showLoginAsModal: false, 
            loginAs: '', 
            temporaryResponse: null,
            specificUser: null,
            specificUserError: '',
            partnersList: [],
            partnerCompanyName: '', 
        };
    }

    componentWillMount = () => {
        this.setState({
            tokenUrl: window.location.hostname === "localhost" ? "localhost:3000" : "klearexpress.com",
        });
    };

    componentDidMount = () => {
        const form = document.getElementById("login-form");

        form.addEventListener("keyup", (e) => {
            if (e.keyCode === 13) {
                document.getElementById("login-button").click();
            }
        });
    };

    togglePopup() {
        const { username } = this.state;
        this.setState({
            showPopup: !this.state.showPopup,
            username,
        });
    }

    getCookieValue = (name) => {
        var b = document.cookie.match("(^|;)\\s*" + "kxCustomerToken" + "\\s*=\\s*([^;]+)");
        return b ? b.pop() : "";
    };


    handleChange = (name, e) => {
        if (name === 'email') {
            if ((this.validateEmail(e) || isListedAdminEmail(e)) && checkEnvForProd()) this.setState({ showKnEmailInput: true })
            else { this.setState({ showKnEmailInput: false, knEmail: '' }) }
        }
        this.setState({ [name]: e });
    }

    validateEmail = (email) => {
        let knEmail = String(email).toLowerCase();
        return /@klearnow.com$/.test(knEmail);
    }

    validateOTP = (otp) => {
        return String(otp)
            .match(
                /^[0-9]{6}$/
            )
    }

    isOtpCheckBoxReq = () => {
        return checkEnvForProd() && !isListedAdminEmail(this.state.email) && this.validateEmail(this.state.email)
    }

    showError = (errorMsg) => {
        this.setState({ error: true, loading: false }, () => {
            document.getElementById("loginError").innerHTML = `<br /><center> ${errorMsg} </center>`;
            setTimeout(() => {
                this.setState({ error: false })
            }, 2000)
        })
    }

    handleSubmit = (e) => {
        console.log("HAMBURGER MENU ....")
        e.preventDefault();
        this.setState({ loading: true })

        if (checkEnvForProd() && this.state.showKnEmailInput) {
            // console.log('tosendKNEmail')
            this.sendOtpToKnEmail()
        } 
        // else if (checkEnvForProd() && this.state.showTokenInput) {
        //     this.checkgeneratedOTP();
        // }
        else {

        const { email, password } = this.state;

        let typeOfUser = this.props.type === "DRAYAGE_PARTNER_USER" 
        ? "DRAYAGE_PARTNER_USER" 
            : "SALES_USER" 
                ? "SALES_USER"
                    : "Customer"

        

        login(email, password, typeOfUser)
            .then((response) => {
                return response.json();
            })
            .then((responseData) => {
                // console.log("responseData", responseData);
                if (responseData.code) {
                    document.getElementById("loginError").innerHTML = `<br /><center> ${responseData.msg} </center>`;
                    this.setState({ error: true, loading: false });
                } else {
                    document.getElementById("loginError").innerHTML = '';
                    this.setState({ loading: false });
                    let token = get(responseData, "eventMessage.user.kxToken", "");
                    let domain = window.location.hostname;
                    const d = new Date();
                    d.setTime(d.getTime() + 2 * 24 * 60 * 60 * 1000);
                    const expires = `expires=${d.toUTCString()}`;
                    let tokenName = this.getTokenName(typeOfUser)
                    document.cookie = `${tokenName}=${token};${expires};domain=${domain};path=/`;
                    if (document.cookie !== '') window.location.reload();
                    return true;
                }
            })
            .then((res) => {
                if (res) {
                    this.setState({ toNextPage: true });
                }
            })
            .catch((err) => {
                document.getElementById("loginError").innerHTML = "<br /><center> An error occurred. Please contact your KlearNow CSM if the issue persists.</center>";
                console.log("ERROR:", err);
                this.setState({ loading: false });
            });
        }
    }

    getTokenName = (typeOfUser) => {
        console.trace("Type Of User :: getTokenName",typeOfUser)
        switch(typeOfUser) {
          case "DRAYAGE_PARTNER_USER" :
            return "kxPartnerToken"
          case "SALES_USER" :
            return "kxSalesToken"
          case "Customer" :
            return "kxCustomerToken"  
        }
    } 

    setTokenToCookie = (responseData) => {
        // Cookie.deleteAllCookie();
        let token = get(responseData, "eventMessage.user.kxToken", "");
        let domain = window.location.hostname
        console.log('company name1', this.state.partnerCompanyName)
    
        // document.cookie = `kxPartnerToken=${token};domain=${domain};path=/`;
    
        if (this.state.loginAs === "specificUser") {
          let token = get(this.state.temporaryResponse, "eventMessage.user.kxToken", "");
          document.cookie = `switchUserToken=${token};domain=${domain};path=/`;
          document.cookie = `kxUserEmail=${this.state.email};domain=${domain};path=/`;
    
          if (this.state.knEmail) {
            console.log('company name', this.state.partnerCompanyName)
            document.cookie = `loggedInAsEmail=${this.state.knEmail};domain=${domain};path=/`;
            document.cookie = `companyName=${this.state.partnerCompanyName};domain=${domain};path=/`;
          } else {
            document.cookie = `loggedInAsEmail=${this.state.email};domain=${domain};path=/`;
          }
        }

        const d = new Date();
        d.setTime(d.getTime() + 2 * 24 * 60 * 60 * 1000);
        const expires = `expires=${d.toUTCString()}`;
        let tokenName = this.getTokenName("DRAYAGE_PARTNER_USER")
        document.cookie = `${tokenName}=${token};${expires};domain=${domain};path=/`
        if (document.cookie !== '') window.location.reload()
    }

    sendOtpToKnEmail = () => {
        this.setState({ loading: true });

        let email = this.state.email,
            knEmail = "";
        if (isListedAdminEmail(email) || !this.state.useCurrentEmail) {
            knEmail = this.state.knEmail;
        } else if (this.state.useCurrentEmail) {
            knEmail = email;
            this.setState({ knEmail: email });
        } else {
            knEmail = email;
            this.setState({ knEmail: email });
        }

        let typeOfUser = isListedAdminEmail(email) ? null : 'DRAYAGE_PARTNER_USER'
        let hashedPassword = this.state.password;
        this.setState({ knEmail });

        // validate email
        if (!this.validateEmail(knEmail)) {
            return this.showError("Invalid KN Email.");
        }

        let portal = `drayagePartner-${this.state.knEmail.split("@")[0]}`;

        sendKnEmail(email, knEmail, portal, hashedPassword, typeOfUser).then(res => { return res.json() }).then(res => {
            if (get(res, 'eventMessage.code', 400) === 200) {
                this.setState({ loading: false, showOtpModal: true });
            } else {
                this.setState({ loading: false })
                return this.showError(res.msg);
            }
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }    

    resendOTP = () => {
        this.sendOtpToKnEmail();
    }

    checkgeneratedOTP = () => {
        let { otp, knEmail, email, password } = this.state;
        if (!otp) {
            return this.showError("Empty Field.");
        }

        if (!this.validateOTP(otp)) {
            return this.showError("Invalid OTP.");
        }

        this.setState({ loading: true });
        const body = {
            token: otp,
            knEmail,
            email,
            hashedPassword: password,
            typeOfUser : isListedAdminEmail(email) ? "SALES_ADMIN_USER" : 'DRAYAGE_PARTNER_USER',
        };
        authenticateGeneratedOTP(body).then(res => { return res.json() }).then(res => {
            if (get(res, 'eventMessage.header.code', 400) === 200) {
                if (isListedAdminEmail(email)) {
                    this.setState({ showLoginAsModal: true, loginAs: 'admin', temporaryResponse: res, loading: false })
                    this.selectSpecificUser()
                }
                else {
                    this.setTokenToCookie(res)
                    this.setState({ showOtpModal: false, loading: false })
                }
            } else {
                this.setState({ showOtpModal: false });
                return this.showError(res.eventMessage.msg);
            }
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    renderOtpPopUpModal = () => {
        return (
            <Modal
                size={'small'}
                open={this.state.showOtpModal}
                closeOnEscape={false}
                className="otp_modal_section"
            >
                <Icon name="close" size="small" onClick={() => this.setState({ showOtpModal: false, otp: "" })} />
                <Modal.Header>Please enter the OTP</Modal.Header>
                <Modal.Content>
                    <FormRow>
                        <Input
                            id="login-otp"
                            value={this.state.otp}
                            onChange={(e) => this.handleChange("otp", e)}
                            label={"ENTER OTP"} singleElement bottomElement
                        />
                    </FormRow>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        onClick={this.resendOTP}
                    >
                        Resend OTP
                    </Button>
                    <Button
                        disabled={this.state.otp.length !== 6} positive
                        onClick={this.checkgeneratedOTP}
                    >
                        Submit
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }

    handleSpecificUsersChange = ({ value }) => {
        const partners = [...this.state.partnersList]
        const selectedPartner = partners.filter((item) => item.value === value)
        this.setState({ specificUser: value, partnerCompanyName: selectedPartner[0].name })
    }

    selectSpecificUser = () => {
        this.setState({ loginAs: "specificUser" })
        this.getPartnersList()
    }

    getPartnersList = () => {
        let responseData = this.state.temporaryResponse;
        let token = get(responseData, "eventMessage.user.kxToken", "")
        if (token) {
            getDrayagePartnersList(token)
                .then(res => { return res.json() })
                .then(res => {
                    let allPartners = get(res.eventMessage, "drayagePartners", [])
                    let arr = []
                    allPartners.map(partner => {
                        let partnerId = get(partner, 'companyProfile.partnerId', '')
                        let text = `(${partnerId}) - ${get(partner, 'companyProfile.name', '')}`
                        arr.push(
                            {
                                key: partnerId,
                                text,
                                value: partnerId,
                                name: get(partner, 'companyProfile.name', ''),
                            }
                        )
                    })
                    this.setState({ partnersList: arr })
                    console.log('allPartners', allPartners, '\n newArr', arr)
                }).catch(error => {
                    console.error(error)
                })
        }
    }

    handleSpecificUserLogin = () => {
        this.setState({ loading: true })
        if (this.state.loginAs === "specificUser") {
            let partnerId = this.state.specificUser;
            let responseData = this.state.temporaryResponse;
            let token = get(responseData, "eventMessage.user.kxToken", "");

            // untill the customer code is given don't let the api make call
            if (!partnerId) {
                this.setState({ specificUserError: true, loading: false }, () => {
                    document.getElementById("specificUserLoginError").innerHTML = `<br /><center> No User selected </center>`;
                    setTimeout(() => {
                        this.setState({ specificUserError: false })
                    }, 2000)
                })
                return
            }
            // call the specific user api
            specificUserLogin(partnerId, token).then(res => { return res.json() }).then(res => {
                this.setState({ loading: false });
                if (res.eventMessage.code === 400) {
                    this.setState({ specificUserError: true }, () => {
                        document.getElementById("specificUserLoginError").innerHTML = `<br /><center> ${res.eventMessage.msg} </center>`;
                        setTimeout(() => {
                            this.setState({ specificUserError: false })
                        }, 2000)
                    })
                } else {
                    this.setTokenToCookie(res);
                }

            }).catch(err => {
                this.setState({ loading: false })
                console.error(err);
                this.showError(err.message)
            })

        } else {
            // simply login using the token
            this.setTokenToCookie(this.state.temporaryResponse);
        }
    }

    renderLoginAsModal = () => {
        return (
            <Modal
                size={'tiny'}
                open={this.state.showLoginAsModal}
                closeOnEscape={false}
                className="otp_modal_section"
            >
                <Icon name="close" size="small" onClick={() => this.setState({ showLoginAsModal: false, loginAs: null, specificUser: null })} />
                <Modal.Header>Login as</Modal.Header>
                <Modal.Content>
                    <FormRow>
                        <div className="loginAs_modal_content">
                            {/* <Radio
                                label='Specific User'
                                name='radioGroup'
                                value='specificUser'
                                checked={this.state.loginAs === 'specificUser'}
                                onChange={this.selectSpecificUser}
                            /> */}

                            {this.state.loginAs === "specificUser" && <Dropdown
                                search
                                placeholder='Select User'
                                clearable
                                selection
                                onChange={(e, data) => this.handleSpecificUsersChange(data)}
                                options={this.state.partnersList}
                            />}
                        </div>
                    </FormRow>
                </Modal.Content>
                {this.state.specificUserError && <div id="specificUserLoginError"></div>}
                <Modal.Actions>
                    <Button
                        disabled={(this.state.loginAs === "specificUser" && (this.state.specificUser === "" || !this.state.specificUser))}
                        loading={this.state.loading}
                        positive
                        onClick={this.handleSpecificUserLogin}>
                        LOGIN
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }

    render() {

        let setImage = this.props.type === "DRAYAGE_PARTNER_USER" ? "images/Login_page.png" : "";
        
        return (
            <div className="mainContainer">
                <div className="flex-container">
                    <div className="top-content">
                        <Segment padded="very" className="login-container">
                            <p className="login-header">Log in to your account.</p>
                            <div id="login-form" className="login-form">
                            {this.state.showOtpModal && this.renderOtpPopUpModal()}
                            {this.state.showLoginAsModal && this.renderLoginAsModal()}
                                <FreeForm>
                                    <FormRow style={{ display: "flex" }}>
                                        <Input
                                            id="login-email"
                                            onChange={(e) => this.handleChange("email", e)}
                                            label={"EMAIL"}
                                            value={this.state.email}
                                            singleElement
                                            topElement
                                        />
                                    </FormRow>
                                    {this.isOtpCheckBoxReq() &&
                                        <Checkbox
                                            className="login-checkbox"
                                            label='Use same email id to get OTP'
                                            onClick={(e, data) => this.handleChange("useCurrentEmail", data.checked)}
                                        />
                                    }
                                    <FormRow>
                                        <Input
                                            id="login-password"
                                            onChange={(e) => this.handleChange("password", e)}
                                            label={"PASSWORD"}
                                            value={this.state.password}
                                            singleElement
                                            password
                                            bottomElement
                                        />
                                    </FormRow>

                                    {this.state.showKnEmailInput &&
                                        <FormRow>
                                            <Input
                                                disabled={this.state.useCurrentEmail}
                                                value={this.state.useCurrentEmail ? this.state.email : this.state.knEmail}
                                                id="login-kn-email"
                                                onChange={(e) => this.handleChange("knEmail", e)}
                                                label={"KN EMAIL"}
                                                singleElement
                                                bottomElement />
                                        </FormRow>
                                    }
                                </FreeForm>

                                <Button disabled={!this.state.email || !this.state.password || this.state.loading} onClick={this.handleSubmit} className="login-button">
                                        {this.state.loading ? <Loader active inline='centered' size='small'/> : 
                                            this.state.showKnEmailInput ? "GET OTP" : "LOG IN"
                                        }
                                    </Button>
                                
                                <div id="loginError"></div>

                                <center>
                                    <p className="forgotLogin">
                                        <Link to="/forgot-password">Forgot Password?</Link>
                                    </p>
                                </center>
                            </div>
                        </Segment>

                        <div className="rs-container">
                            <div>
                                <div className="rs-hero">
                                    <div>
                                        <img src='images/Logo.png' className="loginLogo" />
                                        {/* <span className="loginLogoDrayage">DRAYAGE</span> */}
                                    </div>
                                    <img src={setImage} className="ui image rs-bg" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-wrapper" style={{ "color": "white", "marginTop": "25px" }}>
                        <p>
                            <span className="companyName">
                                <strong>KlearNow Corp.</strong>
                            </span>
                            &nbsp; &nbsp;| &nbsp; &nbsp;
                            <Link to="/view-terms" style={{ "color": "white", "margin-top": "25px" }}>Terms</Link>
                            &nbsp; &nbsp; | &nbsp; &nbsp;
                            <Link to="/privacy" style={{ "color": "white", "margin-top": "25px" }}>Privacy</Link>
                            &nbsp; &nbsp;
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}


export default LoginDrayage;
